module["exports"] = [
  "Leil. ###",
  "Oppgang A",
  "Oppgang B"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nb_NO/address/secondary_address.js
// module id = 2499
// module chunks = 2